<template>
  <DependencyTable
    entity-type="productrun"
    :columns="productRunColumns"
    :meta-data="{ currentPage: 1, resultsPerPage: productRunCount }"
    :items="productRuns"
    :title="$t('productprocessdefinition.dependencies.productRuns.title', { count: productRunCount })"
    :no-results-text="$t('productprocessdefinition.dependencies.productRuns.noResults')"
  />
</template>
<script lang="ts" setup>
import { ProductRunBasicDto } from '@/api/backoffice/clients';
import { PropType, computed } from 'vue';
import DependencyTable from '@/modules/configuration/views/shared/DependencyTable.vue';
import { format } from 'date-fns';

defineProps({
  productRuns: {
    type: Object as PropType<ProductRunBasicDto[]>,
    required: true
  }
});

const productRunCount = 10;

const productRunColumns = computed(() => {
  return [
    {
      accessorKey: 'id',
      header: 'Id',
      enableSorting: true,
      size: 5,
      link: true
    },
    {
      accessorKey: 'status.executionDate',
      header: 'Datum',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true,
      cell: (props) => {
        const status = props.row.original.status;
        if (!status || !status.executionDate) {
          return '-';
        }

        try {
          const executionDate = format(status.executionDate, 'dd.MM.yyyy');
          return executionDate;
        } catch (e) {
          console.log('foutieve datum', status);
          return '-';
        }
      }
    },
    {
      accessorKey: 'status.description',
      header: 'Status',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true
    },
    {
      accessorKey: 'isDryRun',
      header: 'Is Dry Run',
      enableSorting: true,
      sortDescFirst: false,
      size: 30,
      link: true,
      cell: (props) => {
        const val = props.row.original;
        return val.isDryRun ? 'Ja' : 'Neen';
      }
    }
  ];
});
</script>
<style lang="scss" scoped></style>
